"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogger = exports.rootLogger = void 0;
const winston_1 = require("winston");
exports.rootLogger = winston_1.createLogger({
    format: winston_1.format.combine(winston_1.format.splat(), winston_1.format.timestamp({ format: 'YYYY-mm-dd HH:MM:SS' }), winston_1.format.printf(info => {
        const label = info.label || '<root>';
        const { timestamp: ts, message: msg, level } = info;
        return `[${ts}][${label}][${level}] ${msg}`;
    })),
    transports: [
        new winston_1.transports.Console(),
    ],
});
exports.getLogger = (name) => exports.rootLogger.child({
    label: name,
});
